export const generateFlow = (settings) => {
  const flow = [];
  const customPages = settings.custom_pages || [];

  // Helper to check if a page is visible
  const isPageVisible = (pageId) => {
    // Custom pages are always visible if they exist in the order
    if (pageId.startsWith("custom_")) {
      return customPages.some((cp) => cp.id === pageId);
    }
    // Standard pages use the settings.visible flag
    return settings?.settings?.[pageId]?.visible ? true : false;
  };

  // Helper to get custom page data
  const getCustomPageData = (pageId) => {
    return customPages.find((cp) => cp.id === pageId);
  };

  const actualPages = settings.order.filter((pageId) => isPageVisible(pageId));

  actualPages.forEach((pageId, index) => {
    const isCustomPage = pageId.startsWith("custom_");
    const page = isCustomPage ? null : settings.settings[pageId];
    const customPageData = isCustomPage ? getCustomPageData(pageId) : null;

    const nextPageId = actualPages[index + 1] || null;
    // For next route, use slug if it's a custom page
    let nextRoute = nextPageId;
    if (nextPageId?.startsWith("custom_")) {
      const nextCustomPage = getCustomPageData(nextPageId);
      nextRoute = nextCustomPage?.slug || nextPageId;
    }

    const previousPageId = actualPages[index - 1] || null;

    flow.push({
      name: isCustomPage ? (customPageData?.slug || pageId) : pageId,
      pageId: pageId, // Keep the original page ID for reference
      next: nextRoute,
      progress:
        actualPages.length === index + 1
          ? 100
          : ((index + 1) * 100) / actualPages.length,
      previous: previousPageId,
      settings: page,
      customPageData: customPageData,
      isCustomPage: isCustomPage,
    });
  });
  return flow;
};

// const flow = {
//     "/": {
//       name: "start",
//       progress: 0,
//       next: "/contact",
//       previous: null,
//     },
//     "/contact": {
//       name: "contact",
//       progress: 0,
//       next: "/location",
//       previous: "/",
//     },
//     "/location": {
//       name: "location",
//       progress: 30,
//       next: "/info",
//       previous: "/contact",
//     },
